export interface IPromocodeCampaign {
  id: number;
  posConfigId: number;
  name: string;
  startDateTime: string;
  endDateTime: string;
  codes: string[];
  picture: string;
  isPinned: boolean;
  flatValue: number;
  percentageValue: number;
  position: number;
}

export interface IPromocodeCardData {
  id: number;
  name: string;
  code: string;
  picture: string;
  flatValue: number;
  percentageValue: number;
  isApplied: boolean;
}

export enum PromocodeCampaignExpiryTypes {
  EXPIRY_TYPE_DATE = 1,
  EXPIRY_TYPE_DURATION = 2,
}
